import React from 'react'
import style from './about.module.css'

const AboutPage = () => {
    const values = [
        {
            title: "Excellence",
            description: "Nous visons l'excellence dans chaque projet, en dépassant les attentes de nos cl" +
                    "ients."
        }, {
            title: "Innovation",
            description: "Nous restons à la pointe des dernières technologies et méthodologies."
        }, {
            title: "Intégrité",
            description: "La transparence et l'honnêteté guident chacune de nos actions."
        }, {
            title: "Collaboration",
            description: "Nous croyons au pouvoir du travail d'équipe et du partenariat."
        }
    ]

    const team = [
        {
            role: "Direction",
            description: "Une vision stratégique pour guider votre transformation digitale"
        }, {
            role: "Experts Techniques",
            description: "Des développeurs passionnés maîtrisant les dernières technologies"
        }, {
            role: "Consultants",
            description: "Des conseillers expérimentés pour optimiser vos processus"
        }
    ]

    return (
        <div className={style.mainAbout}>
            {/* Hero Section */}
            <div className={style.heroSection}>
                <div className={style.containerHead}>
                    <h1>À propos de Get-Conseil</h1>
                    <p className={style.subtitle}>
                        Transformer vos ambitions en réalité grâce à un conseil d'excellence
                    </p>
                    <p className={style.description}>
                        Depuis notre création, nous accompagnons les entreprises et les particuliers
                        dans leurs décisions stratégiques, techniques et humaines. Notre mission est de
                        vous fournir les meilleures solutions et services, adaptés à vos besoins, à vos
                        projets et aux objectifs fixés pour votre développement.
                    </p>
                </div>
            </div>

            {/* Story Section */}
            <div className={style.storySection}>
                <div className={style.sectionContainer}>
                    <h2 className={style.sectionTitle}>Notre Histoire</h2>
                    <div className={style.storyContent}>
                        <p>
                            Get-Conseil est né d'une conviction profonde : chaque entreprise mérite un
                            accompagnement de qualité, clair et orienté résultats. Dans un monde en
                            constante évolution, nous avons créé un cabinet qui allie expertise technique,
                            vision stratégique et proximité humaine.
                        </p>
                        <p>
                            Notre équipe pluridisciplinaire intervient dans la stratégie, la
                            formation et l'accompagnement personnalisé. Nous croyons que la réussite de nos
                            clients est la meilleure mesure de notre succès.
                        </p>
                    </div>
                </div>
            </div>

            {/* Values Section */}
            <div className={style.valuesSection}>
                <div className={style.sectionContainer}>
                    <h2 className={style.sectionTitle}>Nos Valeurs</h2>
                    <div className={style.valuesGrid}>
                        {values.map((value, index) => (
                            <div key={index} className={style.valueCard}>
                                <div className={style.valueNumber}>{index + 1}</div>
                                <h3>{value.title}</h3>
                                <p>{value.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Team Section */}
            <div className={style.teamSection}>
                <div className={style.sectionContainer}>
                    <h2 className={style.sectionTitle}>Notre Équipe</h2>
                    <p className={style.teamIntro}>
                        Une équipe passionnée et expérimentée, dédiée à votre succès
                    </p>
                    <div className={style.teamGrid}>
                        {team.map((member, index) => (
                            <div key={index} className={style.teamCard}>
                                <div className={style.teamIcon}>
                                    <span>{member
                                            .role
                                            .charAt(0)}</span>
                                </div>
                                <h3>{member.role}</h3>
                                <p>{member.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* GET COST Section */}
            <div className={style.getCostSection}>
                <div className={style.sectionContainer}>
                    <div className={style.branchHeader}>
                        <div className={style.branchIcon}>💰</div>
                        <h2 className={style.sectionTitle}>GET COST</h2>
                        <p className={style.branchTagline}>Conseil Opérationnel en Réduction des Coûts</p>
                    </div>

                    <div className={style.branchContent}>
                        <div className={style.branchDescription}>
                            <p>
                                GET COST est notre branche spécialisée en conseils opérationnels et stratégiques qui accompagnent
                                les entreprises du secteur marchand ou non marchand dans l'optimisation de leurs
                                dépenses de fonctionnement.
                            </p>
                            <div className={style.impactBox}>
                                <h3>Impact Potentiel</h3>
                                <div className={style.statsRow}>
                                    <div className={style.statItem}>
                                        <span className={style.statNumber}>10-70%</span>
                                        <span className={style.statLabel}>du CA couvert</span>
                                    </div>
                                    <div className={style.statItem}>
                                        <span className={style.statNumber}>jusqu'à 40%</span>
                                        <span className={style.statLabel}>d'économies générées</span>
                                    </div>
                                    <div className={style.statItem}>
                                        <span className={style.statNumber}>+10%</span>
                                        <span className={style.statLabel}>augmentation du résultat</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={style.objectivesCard}>
                            <h3>Notre Objectif</h3>
                            <p>
                                Réaliser dans un délai réduit des
                                <strong> économies significatives et pérennes</strong>, sans compromettre le
                                niveau de qualité (Achats - Frais Généraux) ni introduire de risque
                                (fiscal/social).
                            </p>
                            <div className={style.remunerationNote}>
                                <span className={style.noteIcon}>✓</span>
                                <p>
                                    <strong>Rémunération au succès :</strong>
                                    Basée uniquement sur les économies réellement réalisées</p>
                            </div>
                        </div>
                    </div>

                    <div className={style.interventionsSection}>
                        <h3 className={style.subsectionTitle}>Nos Interventions</h3>
                        <div className={style.interventionsGrid}>
                            <div className={style.interventionCard}>
                                <div className={style.interventionIcon}>💼</div>
                                <h4>Finances</h4>
                                <p>Optimisation des processus financiers et réduction des coûts opérationnels</p>
                            </div>
                            <div className={style.interventionCard}>
                                <div className={style.interventionIcon}>👥</div>
                                <h4>Ressources Humaines</h4>
                                <p>Rationalisation des dépenses RH et amélioration de l'efficience</p>
                            </div>
                            <div className={style.interventionCard}>
                                <div className={style.interventionIcon}>🛒</div>
                                <h4>Achats</h4>
                                <p>Négociation et optimisation des contrats fournisseurs</p>
                            </div>
                            <div className={style.interventionCard}>
                                <div className={style.interventionIcon}>🌐</div>
                                <h4>Périmètre Global</h4>
                                <p>Analyse transversale et optimisation de l'ensemble des dépenses</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* GET TRAINING Academy Section */}
            <div className={style.getAcademySection}>
                <div className={style.academyOverlay}></div>
                <div className={style.sectionContainer}>
                    <div className={style.branchHeader}>
                        <div className={style.branchIcon}>🎓</div>
                        <h2 className={style.sectionTitle}>GET TRAINING Academy</h2>
                        <p className={style.branchTagline}>Formation d'Excellence en Négociation Internationale</p>
                    </div>

                    <div className={style.academyContent}>
                        <div className={style.academyIntro}>
                            <p className={style.academyLead}>
                                GET Training Academy organise des séminaires intensifs d'apprentissage et/ou de
                                renforcement de capacités en <strong> négociation internationale</strong>, au Congo ou dans un pays hôte.
                            </p>
                        </div>

                        <div className={style.academyPhilosophy}>
                            <blockquote className={style.quoteBox}>
                                <span className={style.quoteIcon}>"</span>
                                <p>La négociation est un art. Elle a ses règles, ses techniques, ses méthodes,
                                    ses constantes et ses variables.</p>
                            </blockquote>
                            <p className={style.philosophyText}>
                                Maîtriser les bases pour conclure est d'une importance capitale pour toute
                                personne devant négocier avec différents types de collaborateurs et de parties
                                prenantes afin de mener à bien ses projets.
                            </p>
                        </div>

                        <div className={style.academyBenefits}>
                            <h3>Une Expérience Unique</h3>
                            <div className={style.benefitsCards}>
                                <div className={style.benefitItem}>
                                    <span className={style.benefitIcon}>📚</span>
                                    <h4>Apprentissage Intensif</h4>
                                    <p>Techniques et méthodes éprouvées de négociation internationale</p>
                                </div>
                                <div className={style.benefitItem}>
                                    <span className={style.benefitIcon}>🤝</span>
                                    <h4>Networking Professionnel</h4>
                                    <p>Moment de rencontre et d'échange avec les acteurs du secteur</p>
                                </div>
                                <div className={style.benefitItem}>
                                    <span className={style.benefitIcon}>🌍</span>
                                    <h4>Focus Marché Africain</h4>
                                    <p>Contraintes, défis et perspectives d'évolution du continent</p>
                                </div>
                                <div className={style.benefitItem}>
                                    <span className={style.benefitIcon}>💡</span>
                                    <h4>Pratique & Cas Réels</h4>
                                    <p>Mises en situation et études de cas concrets</p>
                                </div>
                            </div>
                        </div>

                        <div className={style.academyCta}>
                            <p>Renforcez vos capacités de négociation et démarquez-vous sur le marché</p>
                            <button className={style.academyBtn}>En savoir plus sur nos formations</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className={style.ctaSection}>
                <div className={style.ctaContainer}>
                    <h2>Prêt à transformer votre vision en réalité ?</h2>
                    <p>Discutons de votre projet et découvrons ensemble comment nous pouvons vous aider</p>
                    <div className={style.ctaButtons}>
                        <button className={style.primaryBtn}>Nous contacter</button>
                        <button className={style.secondaryBtn}>Voir nos services</button>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default AboutPage